import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAbacus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "abacus",
	"data-name": "abacus",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "21.55 0.52 21.55 18.66 2.46 18.66 2.46 0.52"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "plan2plate-icon",
			x: 1.5,
			y: 18.66,
			width: 21,
			height: 3.82
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.45,
			y1: 2.43,
			x2: 21.55,
			y2: 2.43
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 6.27,
			y1: .52,
			x2: 6.27,
			y2: 4.34
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 9.14,
			y1: .52,
			x2: 9.14,
			y2: 4.34
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12,
			y1: .52,
			x2: 12,
			y2: 4.34
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.45,
			y1: 8.16,
			x2: 21.55,
			y2: 8.16
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 10.09,
			y1: 6.25,
			x2: 10.09,
			y2: 10.07
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 12.95,
			y1: 6.25,
			x2: 12.95,
			y2: 10.07
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.73,
			y1: 6.25,
			x2: 17.73,
			y2: 10.07
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 2.45,
			y1: 13.89,
			x2: 21.55,
			y2: 13.89
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 6.27,
			y1: 11.98,
			x2: 6.27,
			y2: 15.8
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 9.14,
			y1: 11.98,
			x2: 9.14,
			y2: 15.8
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 15.82,
			y1: 11.98,
			x2: 15.82,
			y2: 15.8
		})
	]
});
const ForwardRef = forwardRef(SvgAbacus);
export default ForwardRef;
